import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { qrcodesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useBucketsState = () => React.useContext(Context) || {}
export const useBuckets = () => useBucketsState()?.buckets || []

const QUERY = gql`
  query Buckets($page: Int, $search: String, $sort: BucketSort, $filter: BucketFilter) {
    buckets(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      qrcodesCount
      insertedAt
      activated
    }
  }
`

const BucketsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const modalData = useModalData()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { ...filter, types: modalData?.type }
    },
    client: qrcodesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default BucketsLoader
